import { RouteObject } from 'react-router-dom';

import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

import ServiceVisitTypes from '../ServiceVisitTypes';
import { NewServiceVisitType, EditServiceVisitType } from '../pages';

export const ServiceVisitTypesRoutes: RouteObject[] = [
  {
    path: 'service-visit-types',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <ServiceVisitTypes />
      </Authorize>
    ),
  },
  {
    path: 'service-visit-types/new',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <NewServiceVisitType />
      </Authorize>
    ),
  },
  {
    path: 'service-visit-types/:serviceVisitTypeId/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <EditServiceVisitType />
      </Authorize>
    ),
  },
];
